import { ImpersonateCarrierService } from './shared/services/impersonate-carrier.service';
import { ChangeCarrierComponent } from './shared/components/change-carrier/change-carrier.component';
import { CustomerSupportService } from './shared/services/customer-support/customer-support.service';
import { ButtonDropdownComponent } from './shared/components/button-dropdown/button-dropdown.component';
import { CarrierService } from './services/carrier/carrier.service';
import { SupplierService } from './services/supplier/supplier.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HcComponentsModule } from '@hubgroup/hubconnect-ui-commons/';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { UserListComponent } from './components/users/user-list/user-list.component';
import { MatTabsModule } from '@angular/material/tabs';
import { UsersComponent } from './components/users/users.component';
import { CanActivateAuthGuard } from './core/security/auth-gaurd.service';
import { CustomerService } from './services/customer/customer.service';
import { ErrorHandlerService } from './shared/services/error-handler.service';
import { MomentService } from './services/moment/moment.service';
import { PageHeaderComponent } from './shared/components/page-header/page-header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { GeolocationSelectorComponent } from './shared/components/geolocation-selector/geolocation-selector.component';
import { RequestsComponent } from './components/requests/requests.component';
import { RequestModalComponent } from './components/requests/request-modal/request-modal.component';
import { PurchaseOrderService } from './services/purchase-order/purchase-order.service';
import { SuppliersComponent } from './components/suppliers/suppliers.component';
import { SupplierListComponent } from './components/suppliers/list/list.component';
import { SupplierComponent } from './components/suppliers/supplier/supplier.component';
import { UploadSupplierFormComponent } from './components/suppliers/upload-supplier-form/upload-supplier-form.component';
import { UploadSupplierComponent } from './components/suppliers/upload-suppliers/upload-supplier.component';
import { FilterPipe } from './shared/pipes/filter/filter.pipe';
import { FileDropModule } from 'ngx-file-drop';
import { SupplierReleaseRequirementsModalComponent } from './components/customers/customer/supplier-release-requirements-modal/supplier-release-requirements-modal.component';
import { CustomerComponent } from './components/customers/customer/customer.component';
import { CustomerListComponent } from './components/customers/list/list.component';
import { CustomersComponent } from './components/customers/customers.component';
import { EditCustomerEntitlementsComponent } from './components/customers/customer/supplier-release-requirements-modal/edit-customer-entitlements/edit-customer-entitlements.component';
import { AddSupplierComponent } from './components/suppliers/add-supplier/add-supplier.component';
import { UpdateSupplierUserComponent } from './components/users/update-supplier-user/update-supplier-user.component';
import { UpdateSupplierComponent } from './components/users/update-supplier-user/update/update.component';
import { ConfirmUpdateSupplierComponent } from './components/users/update-supplier-user/confirm-update/confirm-update.component';
import { UpdateCarrierComponent } from './components/users/update-carrier-user/update/update.component';
import { ConfirmUpdateCarrierComponent } from './components/users/update-carrier-user/confirm-update/confirm-update.component';
import { UpdateCarrierUserComponent } from './components/users/update-carrier-user/update-carrier-user.component';
import { AddCustomerUserComponent } from './components/users/add-customer-user/add-customer-user.component';
import { ConfirmCustomerComponent } from './components/users/add-customer-user/confirm/confirm.component';
import { CreateCustomerComponent } from './components/users/add-customer-user/create/create.component';
import { AddUserComponent } from './components/users/add-user/add-user.component';
import { AssociatedShipmentPipe } from './shared/pipes/associated-shipment/associated-shipment.pipe';
import { AddressPipe } from './shared/pipes/address/address.pipe';
import { ShipWindowPipe } from './shared/pipes/ship-window/ship-window.pipe';
import { CurrentUserComponent } from './components/current-user/current-user.component';
import { AddSupplierUserComponent } from './components/users/add-supplier-user/add-supplier-user.component';
import { ConfirmSupplierComponent } from './components/users/add-supplier-user/confirm/confirm.component';
import { CreateSupplierComponent } from './components/users/add-supplier-user/create/create.component';
import { AddCarrierUserComponent } from './components/users/add-carrier-user/add-carrier-user.component';
import { ConfirmCarrierComponent } from './components/users/add-carrier-user/confirm/confirm.component';
import { CreateCarrierComponent } from './components/users/add-carrier-user/create/create.component';
import { UpdateCustomerUserComponent } from './components/users/update-customer-user/update-customer-user.component';
import { UpdateCustomerComponent } from './components/users/update-customer-user/update/update.component';
import { ConfirmUpdateCustomerComponent } from './components/users/update-customer-user/confirm-update/confirm-update.component';
import { DeleteUserComponent } from './components/users/delete-user/delete-user.component';
import { DeleteAffiliatedUserComponent } from './components/users/delete-affiliated-user/delete-affiliated-user.component';
import { UpdateAffiliatedUserComponent } from './components/users/update-affiliated-user/update-affiliated-user.component';
import { FiltersService } from './services/filters/filters.service';
import { CarrierUserRequestAccessComponent } from './components/users/add-carrier-user/carrier-request-access/carrier-user-request-access.component';
import { ConfirmUserRequestAccessComponent } from './components/users/add-carrier-user/confirm-request-access/confirm-user-request-access.component';
import { InvalidAccessComponent } from './components/users/add-carrier-user/invalid-access/invalid-access.component';
import { MatDialogModule } from '@angular/material';
import { MassUploadComponent } from './components/suppliers/mass-upload/mass-upload.component';
import { BrowseFileComponent } from './shared/components/browse-file/browse-file.component';
import { MassSuppliersService } from './services/mass-suppliers/mass-suppliers.service';
import { ReviewSuppliersComponent } from './components/suppliers/mass-upload/review-suppliers/review-suppliers.component';
import { ValidSupplierDetailComponent } from './components/suppliers/mass-upload/review-suppliers/valid-supplier-detail/valid-supplier-detail.component';
import { InvalidSupplierDetailComponent } from './components/suppliers/mass-upload/review-suppliers/invalid-supplier-detail/invalid-supplier-detail.component';
import { MaterialModule } from './material.module';
import { PhoneNumberPipe } from './shared/pipes/phone-number/phone-number.pipe';
import { ActionConfirmationModalComponent } from './shared/components/action-confirmation-modal/action-confirmation-modal.component';
import { EditSupplierComponent } from './components/suppliers/edit-supplier/edit-supplier.component';
import { CustomerSupportComponent } from './shared/components/customer-support/customer-support.component';
import { ShipmentsModalComponent } from './components/suppliers/supplier/purchase-order/shipments-modal/shipments-modal.component';
import { UpdateSupplierFormService } from './services/supplier/update-supplier.service';
import { HeaderService } from './shared/services/header/header.service';
import { PurchaseOrderComponent } from './components/suppliers/supplier/purchase-order/purchase-order.component';
import { SupplierUserComponent } from './components/suppliers/supplier/supplier-user/supplier-user.component';
import { SupplierAssociationsComponent } from './components/suppliers/supplier/supplier-associations/supplier-associations.component';
import { SupplierLocationsComponent } from './components/suppliers/supplier/supplier-locations/supplier-locations.component';
import { AssociationsSupplier } from './shared/pipes/associations-supplier/assocaitions-supplier.pipe';
import { UserMassUploadComponent } from './components/users/user-mass-upload/user-mass-upload.component';
import { ReviewUsersComponent } from './components/users/user-mass-upload/review-users/review-users.component';
import { ValidUserDetailComponent } from './components/users/user-mass-upload/review-users/valid-user-detail/valid-user-detail.component';
import { InvalidUserDetailComponent } from './components/users/user-mass-upload/review-users/invalid-user-detail/invalid-user-detail.component';
import { DropdownService } from './services/dropdown/dropdown.service';
import { DeleteCustomerSupplierXrefComponent } from './components/suppliers/supplier/supplier-associations/delete-customer-supplier-xref/delete-customer-supplier-xref.component';
import { AddSupplierCustomerComponent } from './components/customers/add-supplier-customer/add-supplier-customer.component';
import { UserIdleModule } from 'angular-user-idle';
import { RateInquiryConfirmationModalComponent } from './components/customers/customer/supplier-release-requirements-modal/rate-inquiry-confirmation-modal/rate-inquiry-confirmation-modal.component';
import { RequestAccessComponent } from './components/admin-requests/request-access.component';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { ContactSupportComponent } from 'src/app/components/contact-support/contact-support.component'
import { ButtonModule } from '@hubgroup/hubconnect-ui-commons'
import { AnnouncementPopupComponent } from './components/announcement-popup/announcement-popup.component'
import { VendorLocationComponent } from './components/users/carrier-vendor-location/vendor-location.component';

@NgModule({
  declarations: [
    AppComponent,
    UserListComponent,
    UsersComponent,
    AddCustomerUserComponent,
    ConfirmCustomerComponent,
    CreateCustomerComponent,
    PageHeaderComponent,
    GeolocationSelectorComponent,
    AddUserComponent,
    AddSupplierUserComponent,
    ConfirmSupplierComponent,
    CreateSupplierComponent,
    AddCarrierUserComponent,
    ConfirmCarrierComponent,
    CreateCarrierComponent,
    UpdateCustomerUserComponent,
    UpdateCustomerComponent,
    ConfirmUpdateCustomerComponent,
    DeleteUserComponent,
    DeleteAffiliatedUserComponent,
    UpdateAffiliatedUserComponent,
    RequestsComponent,
    RequestModalComponent,
    SuppliersComponent,
    SupplierListComponent,
    SupplierComponent,
    UploadSupplierFormComponent,
    UploadSupplierComponent,
    AddSupplierComponent,
    FilterPipe,
    SupplierReleaseRequirementsModalComponent,
    CustomerComponent,
    CurrentUserComponent,
    CustomerListComponent,
    PurchaseOrderComponent,
    AssociatedShipmentPipe,
    AssociationsSupplier,
    AddressPipe,
    ShipWindowPipe,
    CustomersComponent,
    EditCustomerEntitlementsComponent,
    UpdateSupplierUserComponent,
    UpdateSupplierComponent,
    BrowseFileComponent,
    ConfirmUpdateSupplierComponent,
    ButtonDropdownComponent,
    ConfirmUpdateCarrierComponent,
    UpdateCarrierComponent,
    UpdateCarrierUserComponent,
    MassUploadComponent,
    ReviewSuppliersComponent,
    ValidSupplierDetailComponent,
    InvalidSupplierDetailComponent,
    ShipmentsModalComponent,
    UserMassUploadComponent,
    ReviewUsersComponent,
    ValidUserDetailComponent,
    InvalidUserDetailComponent,
    CarrierUserRequestAccessComponent,
    ConfirmUserRequestAccessComponent,
    InvalidAccessComponent,
    PhoneNumberPipe,
    ActionConfirmationModalComponent,
    EditSupplierComponent,
    SupplierUserComponent,
    SupplierAssociationsComponent,
    SupplierLocationsComponent,
    DeleteCustomerSupplierXrefComponent,
    ChangeCarrierComponent,
    CustomerSupportComponent,
    AddSupplierCustomerComponent,
    RateInquiryConfirmationModalComponent,
    RequestAccessComponent,
    MyAccountComponent,
    ContactSupportComponent,
    AnnouncementPopupComponent,
    VendorLocationComponent
  ],
  entryComponents: [
    ConfirmUserRequestAccessComponent,
    AddSupplierUserComponent,
    AddCustomerUserComponent,
    ActionConfirmationModalComponent,
    EditSupplierComponent,
    AddSupplierComponent,
    ShipmentsModalComponent,
    DeleteUserComponent,
    DeleteAffiliatedUserComponent,
    UpdateAffiliatedUserComponent,
    SupplierReleaseRequirementsModalComponent,
    EditCustomerEntitlementsComponent,
    ChangeCarrierComponent,
    CustomerSupportComponent,
    AddUserComponent,
    RequestModalComponent,
    CurrentUserComponent,
    DeleteCustomerSupplierXrefComponent,
    AddSupplierCustomerComponent,
    RateInquiryConfirmationModalComponent,
    RequestAccessComponent,
    ContactSupportComponent,
    AnnouncementPopupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularSvgIconModule,
    HttpClientModule,
    MatMenuModule,
    SharedModule,
    CoreModule,
    HcComponentsModule,
    MatTabsModule,
    NgxPaginationModule,
    FormsModule,
    FileDropModule,
    TextMaskModule,
    ReactiveFormsModule,
    MatDialogModule,
    MaterialModule,
    ButtonModule,
    UserIdleModule.forRoot({idle: 1800, timeout: 300, ping: 120}) //Set idle time for showing "Stay logged in" popup and auto logout from app
    // @idle: 30mins (1800 millisecs)
    // @timeout 5mins (300 millisecs)
  ],
  providers: [
    CanActivateAuthGuard,
    CustomerService,
    ErrorHandlerService,
    MomentService,
    SupplierService,
    MassSuppliersService,
    CarrierService,
    DropdownService,
    PurchaseOrderService,
    CustomerSupportService,
    FiltersService,
    UpdateSupplierFormService,
    ImpersonateCarrierService,
    HeaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
